<template>
    <section class="valuation-layout  container" id="service-history">
        <h1 class="valuation-layout__header">Free Instant Vehicle Valuation</h1>
        <StepBar />
        <StepLink :step="step - 1" />

        <div v-if="serviceData && selectedVehicle" class="valuation-layout__container">
            <valuation-amount v-if="valuation" :show-cta="false"
                valuation-title="Your Estimated Vehicle Valuation"
                valuation-text="Let's get this figure more accurate and and add your service history.">
            </valuation-amount>

            <vehicle-image />

            <div class="valuation-layout__main-section">
                <h3 class="valuation-layout__title">Vehicle service history</h3>
                <p>We would like to know the service history of your vehicle so we can check the reliability of your car, as it's been checked over at regular intervals.</p>

                <div class="rd-card rd-card--border-top valuation-layout__card">
                    <div class="valuation-layout__condition-container">
                        <form @submit.prevent="submit" ref="form" data-form-name="Valuation - Service History">
                            <h2 class="valuation-layout__heading">We have selected these options based on your previous service history.</h2>

                            <!-- <div  v-if="selectedVehicle && selectedVehicle.lessThanYearOld === true" class="service-history__description">
                                <h3 class="service-history__selected-history-label">First service not due</h3>
                                <p>Due to your vehicle's age, a service has not been required and therefore there is no service history.</p>
                            </div> -->

                            <div>
                                <h3 class="card__heading">Please select one of the below to describe your service history:</h3>
                                    <RadioOptionButtons
                                        :options="serviceOptions"
                                        v-model="serviceHistoryState"
                                        name="service_history"
                                        validate="radio"
                                        validate-message="Please select an option."
                                        error-target="state-error"
                                    />

                                <div v-if="serviceHistoryState" class="service-history__description">
                                    <h3 class="service-history__selected-history-label">You selected: <span v-if="serviceHistoryState !== null"> {{ selectedServiceLabel }} </span></h3>
                                    <p v-if="serviceHistoryState === 'Full'">Your vehicle has a complete service history with verified documentation.</p>
                                    <p v-if="serviceHistoryState === 'Partial'">Most of the servicing records for your vehicle are available and verified but not all.</p>
                                    <p v-if="serviceHistoryState === 'None'">There is no servicing history available for your vehicle.</p>
                                    <p v-if="serviceHistoryState === 'Not Due'">Due to your vehicle's age, a service has not been required and therefore there is no service history.</p>
                                </div>


                                <div v-if="serviceHistoryState === 'Full' || serviceHistoryState === 'Partial'">
                                    <h3 class="card__heading">Please select your type of service history:</h3>

                                    <RadioOptionButtons
                                        :options="serviceTypeOptions"
                                        v-model="serviceHistoryType"
                                        name="service_history_type"
                                        validate="radio"
                                        validate-message="Please select an option."
                                        error-target="type-error"
                                    />

                                    <h3 class="card__heading">Please select one of the below to describe your last service type:</h3>
                                    <RadioOptionButtons
                                        :options="lastServiceOptions"
                                        v-model="lastServiceTypeState"
                                        name="last_service_type"
                                        validate="radio"
                                        validate-message="Please select an option."
                                        error-target="last-service-type-error"
                                    />


                                    <div class="service-history__date-select-area">
                                        <h3 class="card__heading">Please select the date of your last service:</h3>
                                        <select-date
                                            name="last_service_date"
                                            validate-message="Please select an option."
                                            error-target="service-date-error"
                                            :selectedDate="lastServiceDate"
                                            @selected-date="setServiceDataLastServiceDate" />
                                    </div>

                                    <div class="service-history__date-select-area">
                                    <h3 class="card__heading">Please select your vehicles number of services:</h3>
                                    <data id="number-service-count"></data>
                                    <select name="service-history-count" id="service-history-count" class="form-control form-element__input service-history__form-control" v-model="serviceCount"
                                        data-validate="select"
                                        validate-message="Please select an option."
                                        data-error-target="number-service-count"
                                        >
                                        <option :value="0">Select number of services *</option>
                                        <option v-for="count in serviceCountOptions" :key="count" :value="count">
                                            {{ count }}
                                        </option>
                                    </select>

                                    <generic-input
                                        v-if="serviceCount == 'Other'"
                                        form-identifier="service-history-count-other"
                                        input-type="number"
                                        input-name="service-history-count-other"
                                        v-model="serviceCountOther"
                                        input-title="Please enter your number of services."
                                        input-validate="number"
                                        input-validate-message="Please enter your number of services."
                                        :min="1"
                                        :max="99"
                                        :step="1"
                                        :integer-only="true"
                                    />

                                        <!-- <h3 class="card__heading">Please select your vehicles MOT expiry date:</h3>
                                        <select-date
                                            name="mot_expiry_date"
                                            validate-message="Please select an option."
                                            error-target="expiry-date-error"
                                            :selectedDate="motExpiryDate"
                                            :maxDate="expiryMaxDate"
                                            @selected-date="setServiceDataExpiryDate"/> -->
                                    </div>
                                </div>
                            </div>
                        </form>
                    </div>

                    <div class="valuation-layout__button-area">
                        <loading-spinner v-if="submitting" />
                        <template v-else>
                            <button type="button" class="btn btn--primary card__button valuation-layout__button" @click.prevent="submit">
                                <span>Continue</span>
                            </button>
                            <a v-if="authenticated" href="/my-account/valuations" target="_blank"   class="link   link--primary  link--has-icon valuation-layout__button">
                                Save Progress To My Account
                            </a>
                            <a v-else href="#" class="link link--primary  link--has-icon valuation-layout__button" @click.prevent="registerAndSave">
                                Save Progress To My Account
                            </a>
                        </template>
                    </div>

                </div>
            </div>

            <div class="valuation-layout__vehicle-details">
                <VehicleDetails :displayImage="false"/>
                <button @click="newValuation()" class="btn  btn--full-width btn--primary-inverted ">Start new valuation</button>
            </div>
        </div>
    </section>
</template>

<script>
import { mapActions, mapGetters, mapMutations, mapState } from "vuex";
import { StepBar, StepLink, SelectDate, VehicleDetails, ValuationAmount, RadioOptionButtons, LoadingSpinner, VehicleImage } from "../";
import GenericInput from "../../../core/components/Forms/GenericInput.vue";

export default {
    components: {
        VehicleDetails,
        StepBar,
        StepLink,
        SelectDate,
        ValuationAmount,
        RadioOptionButtons,
        LoadingSpinner,
        VehicleImage,
        GenericInput
    },

    data() {
        return {
            submitting: false,
            expiryMaxDate: null,
            validator: false,
            serviceOptions: [
                { label: 'Full', value: 'Full' },
                { label: 'Partial', value: 'Partial' },
                { label: 'None', value: 'None' },
                { label: 'First service not due', value: 'Not Due' }
            ],
            serviceTypeOptions:[
                { label: 'Print', value: 'Print' },
                { label: 'Book', value: 'Book' },
                { label: 'Both', value: 'Both' },
                { label: 'Other', value: 'Other' },
            ],
            lastServiceOptions: [
                { label: 'Full', value: 'Full' },
                { label: 'Minor', value: 'Minor' },
                { label: 'Not Sure', value: 'Not Sure' },
            ],
            serviceCountOptions:[1, 2, 3, 4, 5, 6, 7, 8, 'Other'],
            serviceCount: null,
            serviceCountOther: null,
        };
    },

    methods: {
        ...mapMutations("ValuationExtended", ["setServiceDataExpiryDate", "setServiceDataLastServiceDate", "setServiceDataLastServiceType", "setServiceDataCount", "setServiceDataState", "setServiceDataType"]),
        ...mapActions("ValuationExtended", ["saveAndContinue", "registerAndSave"]),
        ...mapActions("ValuationTool", ["goToPosition", "newValuation"]),

        setExpiryMaxDate() {
            const date = new Date();
            date.setFullYear(date.getFullYear() + 1);
            this.expiryMaxDate = date;
        },

        submit() {
            if (this.submitting) {
                console.warn("Form is already submitting");
                return;
            }
            this.submitting = true;

            this.validator.validateAndSubmit(null, false, formData => {
                return new Promise((resolve, reject) => {
                    this.saveAndContinue()
                        .then(() => {
                            this.submitting = false;
                            resolve();
                        })
                        .catch(error => {
                            this.submitting = false;
                            reject(error);
                        });
                });
            })
            .catch(error => {
                this.submitting = false;
            });
        }
    },

    computed: {
        ...mapState('ValuationTool', ["step",'valuation', 'selectedVehicle']),
        ...mapState('ValuationExtended', ['serviceData']),
        ...mapState('Auth', ['authenticated']),
        ...mapGetters('ValuationTool', ['vehicleImage']),

        formattedAmount() {
            return new Intl.NumberFormat('en-GB', { style: 'currency', currency: 'GBP',  minimumFractionDigits: 0,
            maximumFractionDigits: 0 }).format(this.valuation.valuation);
        },

        selectedServiceLabel() {
            const selectedOption = this.serviceOptions.find(
            option => option.value === this.serviceHistoryState
            );
            return selectedOption ? selectedOption.label : '';
        },

        selectedLastServiceTypeLabel() {
            const selectedLastOption = this.lastServiceOptions.find(
            option => option.value === this.lastServiceTypeState
            );
            return selectedLastOption ? selectedLastOption.label : '';
        },

        numberOfServices: {
            get() {
                return this.$store.state.ValuationExtended.serviceData.NumberOfServices ?? "";
            },
            set(value) {
                this.setServiceDataCount(value);
            }
        },

        serviceHistoryState: {
            get() {
                return this.$store.state.ValuationExtended.serviceData.ServiceHistory ?? "";
            },
            set(value) {
                this.setServiceDataState(value);
            }
        },

        serviceHistoryType: {
            get() {
                return this.$store.state.ValuationExtended.serviceData.ServiceHistoryType ?? "";
            },
            set(value) {
                this.setServiceDataType(value);
            }
        },

        lastServiceDate: {
            get() {
                return this.$store.state.ValuationExtended.serviceData.LastServiceDate ?? "";
            },
            set(value) {
                this.setServiceDataLastServiceDate(value);
            }
        },

        lastServiceTypeState: {
            get() {
                return this.$store.state.ValuationExtended.serviceData.LastServiceType ?? "";
            },
            set(value) {
                this.setServiceDataLastServiceType(value);
            }
        },

        // motExpiryDate: {
        //     get() {
        //         return this.$store.state.ValuationExtended.serviceData.ExpiryDate;
        //     },
        //     set(value) {
        //         this.setServiceDataExpiryDate(value);
        //     }
        // }
    },

    watch: {
        serviceHistoryState() {
            this.$nextTick(() => {
                this.validator = new ContactFormValidator({
                    element: this.$refs['form'],
                    vueForm: true,
                    redesign: true,
                });
            });
        },
        serviceCount(newVal) {
            if (newVal !== 'Other') {
                this.setServiceDataCount(newVal);
                return;
            }
            this.$nextTick(() => {
                this.validator = new ContactFormValidator({
                    element: this.$refs['form'],
                    vueForm: true,
                    redesign: true,
                });
            });
        },
        serviceCountOther(newVal) {
            if (this.serviceCount !== 'Other') {
                return;
            }
            this.setServiceDataCount(newVal);
        }
    },

    mounted() {
        if (this.numberOfServices > 8) {
            this.serviceCount = 'Other';
            this.serviceCountOther = this.numberOfServices;
        } else {
            this.serviceCount = this.numberOfServices;
        }
        this.validator = new ContactFormValidator({
            element: this.$refs['form'],
            vueForm: true,
            redesign: true,
        });
        this.goToPosition('valuation-start')
        this.setExpiryMaxDate();
    },
}
</script>


// WEBPACK FOOTER //
// resources/assets/js/valuation-tool/components/ExactValuationSteps/ServiceHistory.vue